import { createFileRoute, redirect } from "@tanstack/react-router";

import { buildLegalPagePath } from "@/lib/legal-page-path";

export const Route = createFileRoute("/_legal/privacy/")({
  beforeLoad: ({ context: { locale } }) => {
    throw redirect({ href: buildLegalPagePath(locale, "privacy"), statusCode: 301 });
  },
});
